import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { IconModule } from '@spartacus/storefront';

@Component({
  selector: 'sd-tab-bar-item-legacy',
  templateUrl: './tab-bar-item.component.html',
  styleUrls: ['./tab-bar-item.component.scss'],
  imports: [NgIf, IconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdvorTabBarItemComponent {
  @Input() icon: CUSTOM_ICON_TYPE;
  @Input() label: string;
  @Input() badgeCount: number;
  @Input() isActive = false;

  @HostBinding('class')
  get classes(): Record<string, boolean> {
    return {
      tab: true,
      tab_active: this.isActive,
      'tab_with-label': !!this.label,
    };
  }
}
